export enum WINDOW_MODEL_TYPE {
  CONFIG = 'CONFIG',
  VARIABLES = 'VARIABLES',
  SECTIONS = 'SECTIONS',
}

export const WINDOW_TABS_HEIGHT = 24
export const WINDOW_FORM_CONFIG_LINE_HEIGHT = 34
